import { type SVGProps } from 'react';

import { cn } from '@shared/utils';

export interface LwartIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export function LwartIcon({ className, ...props }: Readonly<LwartIconProps>) {
  return (
    <svg
      width="50"
      height="64"
      viewBox="0 0 50 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('text-brand', className)}
      aria-label="Ícone Lwart"
      role="img"
      {...props}
    >
      <path
        d="M20.7533 63.5532C16.2918 63.5532 12.3049 61.275 10.1216 57.383C7.89079 53.5385 7.89079 48.9345 10.1216 45.09L23.5062 21.928C25.1674 18.653 25.4522 15.0933 24.3605 12.0082C23.4587 9.49264 21.6077 7.40426 19.4718 6.45499L16.4816 5.12603L19.4718 0L21.8924 1.09166C25.5471 2.70541 28.4424 5.9329 29.9137 10.0147C31.5749 14.6661 31.1477 19.8396 28.7746 24.6334V24.7758C28.7271 24.7758 15.295 48.0327 15.295 48.0327C14.1085 50.0737 14.1085 52.4468 15.295 54.4877C16.4816 56.5286 18.57 57.7152 20.8957 57.7152H49.7533C49.7533 57.7152 49.9906 59.329 49.9432 60.3732C49.9432 60.6105 49.9432 63.5532 49.9432 63.5532H20.8957H20.7533Z"
        fill="currentColor"
      />
      <path
        d="M43.9153 63.5532V60.563C44.0102 57.4779 42.8711 54.4403 40.7353 52.3044C38.6944 50.216 35.894 49.0769 32.6665 49.0769H12.3048C7.84329 49.0769 3.85638 46.7987 1.67308 42.9067C-0.557692 39.0622 -0.557692 34.4583 1.67308 30.6137L16.3867 5.12603L19.3768 0L21.9873 1.18658C23.1739 1.70867 24.2181 2.46809 24.5503 2.70541L6.75163 33.509C5.56506 35.5499 5.56506 37.9231 6.75163 39.964C7.93821 42.0049 10.0266 43.1915 12.3523 43.1915H32.714C37.5552 43.1915 41.7795 44.9002 44.9595 48.1751C48.1395 51.4501 49.9431 56.0066 49.8007 60.6579V63.5057H43.9153V63.5532Z"
        fill="currentColor"
      />
    </svg>
  );
}
